import { LegalPage } from "../components/LegalPage";

const UPDATED = "June 2026";

const INTRO = [
  "This Privacy Policy explains how Eazikast (\"Eazikast\", \"we\", \"us\") collects, uses, and protects your information when you use our precast-yard planning application, EAZIKAST (the \"Service\").",
];

const SECTIONS = [
  { h: "Information We Collect", p: ["We collect the following categories of information:"], list: [
    "Account information: your name, email address, and a securely hashed password.",
    "Yard data you create: projects/yards, panels, casting-table layouts, concrete loads, schedules, and any shop drawings (PDFs) you upload.",
    "Technical data: basic request and device information needed to operate and secure the Service.",
    "Local data: to support offline use, some of your yard data is stored locally on your device (in your browser's storage).",
  ]},
  { h: "How We Use Your Information", p: ["We use your information to:"], list: [
    "Provide, maintain, and improve the Service.",
    "Authenticate you and keep your account secure.",
    "Store and sync your yard data across sessions and devices.",
    "Respond to support requests and communicate important service notices.",
  ]},
  { h: "Data Storage and Security", p: [
    "Passwords are stored using industry-standard one-way hashing and are never stored in plain text. Access to the Service is authenticated using signed tokens, and data is transmitted over encrypted (HTTPS) connections. While we take reasonable measures to protect your data, no method of transmission or storage is completely secure.",
  ]},
  { h: "Cookies and Local Storage", p: [
    "We use a secure authentication cookie/token to keep you signed in. For offline functionality, the app stores copies of your opened yard data and a sync queue in your browser's local storage. Clearing your browser storage will remove any locally cached, unsynced changes.",
  ]},
  { h: "How We Share Information", p: [
    "We do not sell your personal information. We may share data only with service providers who help us operate the Service (for example, hosting and database providers), and only as necessary to provide the Service, or where required by law.",
  ]},
  { h: "Data Retention", p: [
    "We retain your account and yard data for as long as your account is active. When you delete a yard or your account, the associated data is removed from our active systems. Backups, if any, are cycled out over time.",
  ]},
  { h: "Your Rights", p: ["Depending on your location, you may have the right to:"], list: [
    "Access the personal information we hold about you.",
    "Correct inaccurate information.",
    "Request deletion of your account and associated data.",
    "Export the yard data you have created.",
  ]},
  { h: "Children's Privacy", p: [
    "The Service is intended for professional and business use and is not directed to children under the age of 16. We do not knowingly collect personal information from children.",
  ]},
  { h: "Changes to This Policy", p: [
    "We may update this Privacy Policy from time to time. Material changes will be reflected by updating the \"Last updated\" date above. Continued use of the Service after changes take effect constitutes acceptance of the revised policy.",
  ]},
  { h: "Contact", p: [
    "For privacy questions or to exercise your rights, contact us at kanyemacgregor@eazikast.com.",
  ]},
];

export default function Privacy() {
  return <LegalPage testid="privacy-page" title="Privacy Policy" updated={UPDATED} intro={INTRO} sections={SECTIONS} />;
}
